import 'twin.macro'

import Typography from 'components/UI/Typography'
import dayjs from 'dayjs'
import { useAppSelector } from 'hooks'
import { useEffect, useMemo } from 'react'
import { buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar'
import { useTranslation } from 'react-i18next'
import { useTimer } from 'react-timer-hook'
import { getNotificationsSelector } from 'redux/store/slices/wsSlice'
import { ApplicationEvents } from 'share/enums/events'
import tw from 'twin.macro'
import { getWsStepStatuses } from 'utils'
import Emitter from 'utils/emitter'

const circularProgressStyle = buildStyles({
  pathColor: `#72BF44`,
  trailColor: `var(--bg-landing-toggle)`,
  backgroundColor: `var(--bg-landing-toggle)`
})

const DamuCountdown = () => {
  // Tools
  const { t } = useTranslation()

  // Selectors
  const { DAMU_CREATE_APPLICATION, DAMU_OBLIGATION_CHECK } = useAppSelector(getNotificationsSelector)

  // Hooks
  const { seconds, minutes, hours } = useTimer({
    expiryTimestamp: dayjs().add(7, 'hours').add(59, 'minutes').add(59, 'seconds').toDate()
  })

  // Computed values
  const isDamuDecisionReady = useMemo(
    () => getWsStepStatuses(DAMU_CREATE_APPLICATION, DAMU_OBLIGATION_CHECK) === 'DONE',
    [DAMU_CREATE_APPLICATION, DAMU_OBLIGATION_CHECK]
  )

  // Effects
  useEffect(() => {
    if (!isDamuDecisionReady) return
    Emitter.emit(ApplicationEvents.NAVIGATE_TO_NEXT_PAGE)
  }, [isDamuDecisionReady])

  return (
    <div tw='max-w-[620px] h-[calc(100vh - 84px)] flex items-center justify-center flex-col mx-auto px-5'>
      <div className='flex gap-4'>
        <div className='w-[96px]'>
          <CircularProgressbarWithChildren
            value={7 - hours}
            maxValue={7}
            strokeWidth={2}
            styles={circularProgressStyle}
          >
            <Typography twStyle={tw`font-bold text-[44px] leading-[60px] text-[#4F9D3A] tracking-[-0.35px]`}>
              {hours < 10 ? `0${hours}` : hours}
            </Typography>
          </CircularProgressbarWithChildren>
          <Typography twStyle={tw`text-base leading-[20xp] font-bold text-[#4F9D3A] text-center mt-4`}>
            Часов
          </Typography>
        </div>
        <div className='w-[96px]'>
          <CircularProgressbarWithChildren
            value={60 - minutes}
            maxValue={60}
            strokeWidth={2}
            styles={circularProgressStyle}
          >
            <Typography twStyle={tw`font-bold text-[44px] leading-[60px] text-[#4F9D3A] tracking-[-0.35px]`}>
              {minutes < 10 ? `0${minutes}` : minutes}
            </Typography>
          </CircularProgressbarWithChildren>
          <Typography twStyle={tw`text-base leading-[20xp] font-bold text-[#4F9D3A] text-center mt-4`}>
            Минут
          </Typography>
        </div>
        <div className='w-[96px]'>
          <CircularProgressbarWithChildren
            value={60 - seconds}
            maxValue={60}
            strokeWidth={2}
            styles={circularProgressStyle}
          >
            <Typography twStyle={tw`font-bold text-[44px] leading-[60px] text-[#4F9D3A] tracking-[-0.35px]`}>
              {seconds < 10 ? `0${seconds}` : seconds}
            </Typography>
          </CircularProgressbarWithChildren>
          <Typography twStyle={tw`text-base leading-[20xp] font-bold text-[#4F9D3A] text-center mt-4`}>
            Секунд
          </Typography>
        </div>
      </div>
      <h1 tw='text-[18px]  md:text-2xl leading-[24px] md:leading-8 tracking-[-0.35px] text-center font-bold mt-4'>
        {t('flow-request-sended')}
      </h1>
      <Typography variant='subbody' text twStyle={tw`text-center max-w-[454px] mt-4 text-grey-dark`}>
        {t('flow-eigth-hours')}
      </Typography>
    </div>
  )
}

export default DamuCountdown
